<section
  [ngClass]="{ 'card__container--horizontal-layout': horizontalLayout(), 'card__container--virtual-scroll': virtualScroll() }"
  class="card__container" fxLayout="row wrap" fxLayoutAlign="start"
  fxLayoutGap="15px">
  <ng-content />
</section>
